import { render } from "./BoxInfo.component.vue?vue&type=template&id=2523eea4"
import script from "./BoxInfo.component.vue?vue&type=script&lang=js"
export * from "./BoxInfo.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sharedComponents/BoxInfo.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2523eea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2523eea4', __exports__)) {
    console.log('reload')
    api.reload('2523eea4', __exports__)
  }
  
  module.hot.accept("./BoxInfo.component.vue?vue&type=template&id=2523eea4", () => {
    console.log('re-render')
    api.rerender('2523eea4', render)
  })

}


export default __exports__